/* ==========================================================================
   Divine Hindu — Reports (₹1) grid.
   Click "Get This Report" -> birth-details popup -> adds the report (₹1)
   + one Processing Fee (₹99) with the details as line-item properties.
   Countdown ends tonight. GoKwik-safe (/cart/add.js + window.DivineCart).
   ========================================================================== */
(function () {
  'use strict';
  function reportText(key, fallback) {
    var node = document.querySelector('[data-report-labels]');
    if (!node) return fallback;
    try { var labels = JSON.parse(node.textContent); return typeof labels[key] === 'string' ? labels[key] : fallback; }
    catch (e) { return fallback; }
  }
  var LSK = 'dh_report_birth';
  var pending = null; /* {reportVid, feeVid, title, handle} */
  var FIELDS = ['name', 'gender', 'dob', 'time', 'place', 'wa'];

  /* --- Some reports need TWO people (Kundli matching, Vivah muhurat), so
         their popup runs in two steps: Person 1 → Next → Person 2 → Add. --- */
  var isMatch = false, step = 1, personA = null, attrKey = '';
  /* extra handles can be listed on the section: data-two-person="handle-a,handle-b" */
  function extraHandles() {
    var g = document.querySelector('[data-report-grid]');
    var raw = g ? (g.getAttribute('data-two-person') || '') : '';
    return raw.toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function matchReport(title, handle) {
    var t = ((title || '') + ' ' + (handle || '')).toLowerCase();
    if (t.indexOf('match') > -1 || t.indexOf('milan') > -1) return true;
    if (t.indexOf('vivah') > -1 || t.indexOf('muhurat') > -1 || t.indexOf('muhurt') > -1) return true;
    var h = (handle || '').toLowerCase();
    return h && extraHandles().indexOf(h) > -1;
  }
  /* cart-attribute key — kept per-report so two of them in one cart never clash */
  function detailsKey(title, handle) {
    var t = ((title || '') + ' ' + (handle || '')).toLowerCase();
    if (t.indexOf('vivah') > -1 || t.indexOf('muhurat') > -1 || t.indexOf('muhurt') > -1) return 'Vivah Muhurat Details';
    if (t.indexOf('match') > -1 || t.indexOf('milan') > -1) return 'Kundli Matching Details';
    var short = (title || 'Report').split('—')[0].trim();
    return (short || 'Report') + ' Details';
  }

  /* Clears a stale "… Details" cart attribute when its report is no longer in
     the cart (Shopify keeps attributes after a line — or the whole cart — is
     emptied, and GoKwik would forward them onto an unrelated order). Only ever
     touches keys this section itself generates. */
  function pruneAttrs() {
    var managed = {};
    document.querySelectorAll('[data-report-add]').forEach(function (b) {
      var h = b.getAttribute('data-handle') || '';
      var card = b.closest('[data-report-card]');
      var nm = card ? card.querySelector('.dhrep-card__name') : null;
      var t = nm ? nm.textContent.trim() : '';
      if (h && matchReport(t, h)) managed[detailsKey(t, h)] = h;
    });
    var keys = Object.keys(managed);
    if (!keys.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var inCart = {};
      (c.items || []).forEach(function (i) { inCart[i.handle] = 1; });
      var clear = null;
      keys.forEach(function (k) {
        if ((c.attributes || {})[k] && !inCart[managed[k]]) { clear = clear || {}; clear[k] = ''; }
      });
      if (!clear) return;
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: clear })
      })['catch'](function () {});
    })['catch'](function () {});
  }

  /* ---------- countdown to tonight ---------- */
  function initCountdown() {
    var els = document.querySelectorAll('[data-report-countdown]');
    if (!els.length) return;
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
      var diff = end - now; if (diff < 0) diff = 0;
      var h = Math.floor(diff / 36e5), m = Math.floor((diff % 36e5) / 6e4), s = Math.floor((diff % 6e4) / 1000);
      var str = (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
      els.forEach(function (e) { e.textContent = str; });
    }
    tick();
    if (!window.__dhRepCd) { window.__dhRepCd = setInterval(tick, 1000); }
  }

  /* ---------- modal ---------- */
  function modalEl() { return document.querySelector('[data-report-modal]'); }
  function savedDetails() { try { return JSON.parse(localStorage.getItem(LSK) || '{}'); } catch (e) { return {}; } }
  function fillForm(mo, v) {
    v = v || {};
    FIELDS.forEach(function (k) { var i = mo.querySelector('[data-f="' + k + '"]'); if (i) i.value = v[k] || ''; });
    mo.querySelectorAll('[data-f]').forEach(function (i) { i.classList.remove('err'); });
  }
  /* paints the popup for the current step. For every report except Kundli
     matching this just restores the original single-person popup. */
  function renderStep() {
    var mo = modalEl(); if (!mo) return;
    var stepEl = mo.querySelector('[data-report-step]');
    var backEl = mo.querySelector('[data-report-back]');
    var btn = mo.querySelector('[data-report-modal-submit]');
    var waIn = mo.querySelector('[data-f="wa"]');
    var waWrap = waIn ? (waIn.closest('label') || waIn.parentNode) : null;
    var label = (btn && btn.getAttribute('data-label')) || reportText('cart_label', 'Add to Cart →');
    var er = mo.querySelector('[data-report-modal-err]'); if (er) er.hidden = true;
    if (waWrap) waWrap.style.display = '';
    if (!isMatch) {
      if (stepEl) stepEl.hidden = true;
      if (backEl) backEl.hidden = true;
      if (btn) btn.textContent = label;
      fillForm(mo, savedDetails());
    } else if (step === 1) {
      if (stepEl) { stepEl.hidden = false; stepEl.innerHTML = '<b>' + reportText('step_one', 'Step 1 of 2 · Person 1') + '</b>' + reportText('step_one_detail', 'Birth details of the first person. You’ll fill the second person’s details on the next screen.'); }
      if (backEl) backEl.hidden = true;
      if (btn) btn.textContent = reportText('next_person', 'Next → Person 2');
      fillForm(mo, personA || savedDetails());
    } else {
      if (stepEl) { stepEl.hidden = false; stepEl.innerHTML = '<b>' + reportText('step_two', 'Step 2 of 2 · Person 2') + '</b>' + reportText('step_two_detail', 'Now the birth details of the second person — both kundlis are read together for this report.'); }
      if (backEl) backEl.hidden = false;
      if (waWrap) waWrap.style.display = 'none'; /* delivery number already taken from Person 1 */
      if (btn) btn.textContent = label;
      fillForm(mo, {});
    }
    var first = mo.querySelector('[data-f="name"]'); if (first) setTimeout(function () { try { first.focus(); } catch (e) {} }, 120);
  }
  function openModal(reportVid, feeVid, title, handle, total) {
    var mo = modalEl();
    if (!mo) { addToCart(reportVid, feeVid, null); return; }
    pending = { reportVid: reportVid, feeVid: feeVid, title: title, handle: handle };
    isMatch = matchReport(title, handle);
    attrKey = isMatch ? detailsKey(title, handle) : '';
    step = 1; personA = null;
    var t = mo.querySelector('[data-report-modal-title]'); if (t && title) t.textContent = title;
    var price=mo.querySelector('[data-report-modal-total]'); if(price)price.textContent=total ? (reportText('total', 'Total:')+' '+total+' '+reportText('processing', 'including processing fee')) : '';
    renderStep();
    mo.classList.add('is-open');
  }
  function closeModal() {
    var mo = modalEl();
    if (mo) {
      mo.classList.remove('is-open');
      var waIn = mo.querySelector('[data-f="wa"]');
      var waWrap = waIn ? (waIn.closest('label') || waIn.parentNode) : null;
      if (waWrap) waWrap.style.display = '';
    }
    pending = null; isMatch = false; step = 1; personA = null; attrKey = '';
  }
  function goBack() { if (isMatch && step === 2) { step = 1; renderStep(); } }

  function readForm(mo) {
    var f = {};
    FIELDS.forEach(function (k) { var i = mo.querySelector('[data-f="' + k + '"]'); f[k] = i ? i.value.trim() : ''; });
    return f;
  }
  function personLine(p) {
    return p.name + (p.gender ? ' (' + p.gender + ')' : '') + ', DOB ' + p.dob + ', ' + (p.time || 'time not sure') + ', ' + p.place;
  }

  function submitModal() {
    var mo = modalEl(); if (!mo || !pending) return;
    var f = readForm(mo);
    mo.querySelectorAll('[data-f]').forEach(function (i) { i.classList.remove('err'); });
    var needWa = !(isMatch && step === 2); /* person 2 reuses person 1's WhatsApp number */
    var bad = [];
    if (!f.name) bad.push('name');
    if (!f.gender) bad.push('gender');
    if (!f.dob) bad.push('dob');
    if (!f.place) bad.push('place');
    if (needWa && (f.wa || '').replace(/\D/g, '').length < 10) bad.push('wa');
    if (bad.length) {
      bad.forEach(function (k) { var i = mo.querySelector('[data-f="' + k + '"]'); if (i) i.classList.add('err'); });
      var er = mo.querySelector('[data-report-modal-err]');
      if (er) {
        er.textContent = needWa
          ? reportText('required', 'Please fill all fields (gender and a valid 10-digit WhatsApp number).')
          : reportText('second_required', 'Please fill the second person’s name, gender, date of birth and birth place.');
        er.hidden = false;
      }
      return;
    }

    /* step 1 of the matching report — remember person 1, show a blank form for person 2 */
    if (isMatch && step === 1) {
      personA = f;
      try { localStorage.setItem(LSK, JSON.stringify(f)); } catch (e) {}
      step = 2;
      renderStep();
      return;
    }

    var props, attrs = null;
    if (isMatch) {
      var A = personA, B = f;
      props = {
        'Person 1 · Full Name': A.name, 'Person 1 · Gender': A.gender, 'Person 1 · Date of Birth': A.dob,
        'Person 1 · Birth Time': A.time || 'Not sure', 'Person 1 · Birth Place': A.place,
        'Person 2 · Full Name': B.name, 'Person 2 · Gender': B.gender, 'Person 2 · Date of Birth': B.dob,
        'Person 2 · Birth Time': B.time || 'Not sure', 'Person 2 · Birth Place': B.place,
        'WhatsApp Number': A.wa
      };
      /* mirrored into cart attributes too — GoKwik forwards these onto the order */
      attrs = {};
      attrs[attrKey || 'Kundli Matching Details'] = 'Person 1 — ' + personLine(A) + ' | Person 2 — ' + personLine(B) + ' | WhatsApp: ' + A.wa;
    } else {
      try { localStorage.setItem(LSK, JSON.stringify(f)); } catch (e) {}
      props = { 'Full Name': f.name, 'Gender': f.gender, 'Date of Birth': f.dob, 'Birth Time': f.time || 'Not sure', 'Birth Place': f.place, 'WhatsApp Number': f.wa };
    }

    var btn = mo.querySelector('[data-report-modal-submit]');
    if (btn) { btn.disabled = true; btn.textContent = reportText('adding', 'Adding…'); }
    addToCart(pending.reportVid, pending.feeVid, props, function (ok) {
      if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || reportText('cart_label', 'Add to Cart →'); }
      if (ok) {
        if (attrs) {
          fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          })['catch'](function () {});
        }
        closeModal();
      }
      setTimeout(pruneAttrs, 1500);
    });
  }

  /* ---------- add to cart (GoKwik-safe) ---------- */
  function addToCart(reportVid, feeVid, props, cb) {
    var item = { id: parseInt(reportVid, 10), quantity: 1 };
    if (props) item.properties = props;
    var items = [item];
    if (feeVid) items.push({ id: parseInt(feeVid, 10), quantity: 1 });
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        if (window.DivineCart) { window.DivineCart.refresh(); window.DivineCart.open(); }
        else {
          window.__dhOpenCartOnReady = 1;
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r2) { return r2.json(); })
            .then(function (c) { document.querySelectorAll('[data-cart-count], .header-cart-count').forEach(function (el) { el.textContent = c.item_count; }); })['catch'](function () {});
        }
        if (cb) cb(true);
      })['catch'](function () { if (cb) cb(false); });
  }

  /* ---------- bind ---------- */
  function init() {
    initCountdown();
    if (!window.__dhRepPruned) {
      window.__dhRepPruned = 1;
      setTimeout(pruneAttrs, 600);
      document.addEventListener('dh:cart', function () { setTimeout(pruneAttrs, 400); });
    }
    document.querySelectorAll('[data-report-add]').forEach(function (b) {
      if (b.__init) return; b.__init = 1;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var grid = b.closest('[data-report-grid]');
        var feeVid = grid ? grid.getAttribute('data-fee-vid') : '';
        var card = b.closest('[data-report-card]');
        var title = b.getAttribute('data-title') || '';
        if (!title && card) { var nm = card.querySelector('.dhrep-card__name'); title = nm ? nm.textContent.trim() : ''; }
        else { var sec = b.closest('.dhdd-target'); if (sec) { var h = sec.querySelector('h3'); } }
        openModal(b.getAttribute('data-vid'), feeVid, title, b.getAttribute('data-handle') || '', b.getAttribute('data-total') || '');
      });
    });
    var mo = modalEl();
    if (mo && !mo.__init) {
      mo.__init = 1;
      mo.addEventListener('click', function (e) {
        if (e.target === mo || e.target.closest('[data-report-modal-close]')) { closeModal(); return; }
        if (e.target.closest('[data-report-back]')) { e.preventDefault(); goBack(); return; }
        if (e.target.closest('[data-report-modal-submit]')) { e.preventDefault(); submitModal(); }
      });
      var form = mo.querySelector('form'); if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submitModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 40); });
})();
